// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: ixb95naDvLzR
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicMilestoneInstance.module.css"; // plasmic-import: ixb95naDvLzR/css

createPlasmicElementProxy;

export const PlasmicMilestoneInstance__VariantProps = new Array();

export const PlasmicMilestoneInstance__ArgProps = new Array(
  "milestoneTitle",
  "milestoneNumber",
  "milestoneAmount",
  "milestoneStatus"
);

const $$ = {};

function PlasmicMilestoneInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox___0CEk)}>
        {renderPlasmicSlot({
          defaultContents: (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___4Iq8K
              )}
            >
              {"1"}
            </div>
          ),

          value: args.milestoneNumber,
          className: classNames(sty.slotTargetMilestoneNumber)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__tYdj)}>
        <div className={classNames(projectcss.all, sty.freeBox__f15Mm)}>
          {renderPlasmicSlot({
            defaultContents: "Initial Setup",
            value: args.milestoneTitle,
            className: classNames(sty.slotTargetMilestoneTitle)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__s1Wd)}>
          {renderPlasmicSlot({
            defaultContents: "$300 ",
            value: args.milestoneAmount,
            className: classNames(sty.slotTargetMilestoneAmount)
          })}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__lp25R)}>
          {renderPlasmicSlot({
            defaultContents: "Submitted Dec 15",
            value: args.milestoneStatus,
            className: classNames(sty.slotTargetMilestoneStatus)
          })}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMilestoneInstance__ArgProps,
          internalVariantPropNames: PlasmicMilestoneInstance__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMilestoneInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMilestoneInstance";
  } else {
    func.displayName = `PlasmicMilestoneInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicMilestoneInstance = Object.assign(
  // Top-level PlasmicMilestoneInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicMilestoneInstance
    internalVariantProps: PlasmicMilestoneInstance__VariantProps,
    internalArgProps: PlasmicMilestoneInstance__ArgProps
  }
);

export default PlasmicMilestoneInstance;
/* prettier-ignore-end */
